<template>
  <v-row
    :class="['checkout-pane pt-4', { scrollable: !['xs', 'sm'].includes($mq) }]"
    wrap
  >
    <v-col cols="12" md="10">
      <v-row v-if="getAvailabilities.length" wrap class="flex-column">
        <v-col class="cart--wrap py-0" id="cart">
          <Cart :disabled="getPlacingOrder" />
        </v-col>
        <v-col class="pb-0 special-instrux--wrap">
          <CheckoutTip />
          <CheckoutSpecialInstructions />
          <CheckoutGiftDetails />
        </v-col>
        <v-col>
          <CheckoutPaymentAcknowledgement />
          <CheckoutButtons />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import _includes from 'lodash/includes'

import Cart from '@/components/Cart'
import CheckoutButtons from '@/components/CheckoutButtons'
import CheckoutSpecialInstructions from '@/components/CheckoutSpecialInstructions'
import CheckoutGiftDetails from '@/components/CheckoutGiftDetails'
import CheckoutPaymentAcknowledgement from '@/components/CheckoutPaymentAcknowledgement'
import CheckoutTip from '@/components/CheckoutTip'
export default {
  name: 'CheckoutPane',
  components: {
    Cart,
    CheckoutButtons,
    CheckoutSpecialInstructions,
    CheckoutGiftDetails,
    CheckoutPaymentAcknowledgement,
    CheckoutTip,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('cart', ['getPlacingOrder', 'getTipFromCart', 'getTheCart']),
    ...mapGetters('availabilities', ['getAvailabilities']),
    ...mapGetters('itemAndSection', ['getTipItem']),
  },
  methods: {
    _includes,
  },
}
</script>

<style>
.checkout-pane.scrollable {
  height: calc(100vh - 60px);
  overflow-x: auto;
  position: sticky;
  top: 40px;
}
</style>
